import {
  DASHBOARD_COUNT_REQ,
  DASHBOARD_COUNT_SUCCESS,
  DASHBOARD_COUNT_ERROR,
  GET_ORDER_REQ,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ALLCUSTOMER_REQ,
  GET_ALLCUSTOMER_SUCCESS,
  GET_ALLCUSTOMER_ERROR,
  ALLOW_CUSTOMER_REQ,
  ALLOW_CUSTOMER_SUCCESS,
  ALLOW_CUSTOMER_ERROR,
  RESTRICT_CUSTOMER_REQ,
  RESTRICT_CUSTOMER_SUCCESS,
  RESTRICT_CUSTOMER_ERROR,
  GET_ORDER_BY_ID_REQ,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_ERROR,
  ORDER_APPROVAL_REQ,
  ORDER_APPROVAL_SUCCESS,
  ORDER_APPROVAL_ERROR,
  GET_NOTIFICATION_REQ,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_ERROR,
  GET_LOGISTICS_REQ,
  GET_LOGISTICS_SUCCESS,
  GET_LOGISTICS_ERROR,
  GET_LOG_PARTNER_REQ,
  GET_LOG_PARTNER_SUCCESS,
  GET_LOG_PARTNER_ERROR,
  GET_MANUFACTURE_PLANTS_REQ,
  GET_MANUFACTURE_PLANTS_SUCCESS,
  GET_MANUFACTURE_PLANTS_ERROR,
  GET_LOGISTICS_PARTNERS_REQ,
  GET_LOGISTICS_PARTNERS_SUCCESS,
  GET_LOGISTICS_PARTNERS_ERROR,
  PLANT_ACTIVATION_REQ,
  PLANT_ACTIVATION_SUCCESS,
  PLANT_ACTIVATION_ERROR,
  GET_LOGISTICS_ORDER_REQ,
  GET_LOGISTICS_ORDER_SUCCESS,
  GET_LOGISTICS_ORDER_ERROR,
  GET_LOGISTIC_BY_ID_REQ,
  GET_LOGISTIC_BY_ID_SUCCESS,
  GET_LOGISTIC_BY_ID_ERROR,
  PLANT_REJECTION_REQ,
  PLANT_REJECTION_SUCCESS,
  PLANT_REJECTION_ERROR,
  LOGISTICS_REJECTION_SUCCESS,
  LOGISTICS_REJECTION_ERROR,
  LOGISTICS_REJECTION_REQ,
  PLANT_TAB_PRODUCT_KEY_REQ,
  LOGISTICS_ACTIVATION_REQ,
  LOGISTICS_ACTIVATION_SUCCESS,
  LOGISTICS_ACTIVATION_ERROR,
} from "../constants";
const componentName = window.location.pathname;
let url = `/${componentName.split("/")[componentName.split("/")?.length - 1]}`;
const plantId = componentName.split("/")[componentName.split("/").length - 2];

let key = "1";
console.log("componentName==>", url);
switch (url) {
  case "/dashboard":
    key = "1";

    break;
  case "/contractors":
    key = "2";

    break;
  case "/rmx":
    key = "3";

  case `/orders`:
    key = "3";

    break;
  case "/logistics":
    key = "4";

    break;
  case "/employees":
    key = "5";

    break;
  case "/product":
    key = "6";

    break;
  case "/account":
    key = "7";

    break;
  default:
    key = key;
}

const initialState = {
  orderCount: {},
  isLodadingCount: false,
  errorCount: null,
  isOrder: false,
  isLogisticLoading: false,
  orders: [],
  manufacturePlant: [],
  logisticPartner: [],
  orderError: null,
  accounts: [],
  allowedAccount: false,
  metaData: {},
  logisticmetaData: {},
  allowed_for_credit_purchase: false,
  orderDetail: {},
  logisticDetail: {},
  notification: [],
  logistics: [],
  log_partner: [],
  logisticOrder: [],
  plantkeyTab: key,
  approvalLoader: false,
  rejectionLoder:false
};
export function DashboardReducer(state = initialState, action) {
  console.log("DASHBOARD_REDUCER==>", action);

  switch (action.type) {
    case DASHBOARD_COUNT_REQ: {
      return {
        ...state,
        isLodadingCount: true,
        orderCount: {},
      };
    }
    case DASHBOARD_COUNT_SUCCESS: {
      return {
        ...state,
        isLodadingCount: false,
        orderCount: action.payload,
      };
    }
    case DASHBOARD_COUNT_ERROR: {
      return {
        ...state,
        isLodadingCount: false,
      };
    }
    case GET_ORDER_REQ: {
      return {
        ...state,
        isOrder: true,
        orders: [],
      };
    }
    case GET_ORDER_SUCCESS: {
      return {
        ...state,
        isOrder: false,
        orders: action.payload,
        metaData: action.metaData,
      };
    }
    case GET_ORDER_ERROR: {
      return {
        ...state,
        isOrder: false,
      };
    }

    case GET_LOGISTICS_ORDER_REQ: {
      return {
        ...state,
        isOrder: true,
        orders: [],
      };
    }
    case GET_LOGISTICS_ORDER_SUCCESS: {
      return {
        ...state,
        isOrder: false,
        logisticOrder: action.payload,
        metaData: action.metaData,
      };
    }
    case GET_LOGISTICS_ORDER_ERROR: {
      return {
        ...state,
        isOrder: false,
      };
    }

    case GET_MANUFACTURE_PLANTS_REQ: {
      return {
        ...state,
        isOrder: true,
        manufacturePlant: [],
      };
    }
    case GET_MANUFACTURE_PLANTS_SUCCESS: {
      return {
        ...state,
        isOrder: false,
        manufacturePlant: action.payload,
        metaData: action.metaData,
      };
    }
    case GET_MANUFACTURE_PLANTS_ERROR: {
      return {
        ...state,
        isOrder: false,
      };
    }

    case GET_LOGISTICS_PARTNERS_REQ: {
      return {
        ...state,
        isLogisticLoading: true,
        logisticPartner: [],
      };
    }
    case GET_LOGISTICS_PARTNERS_SUCCESS: {
      return {
        ...state,
        isLogisticLoading: false,
        logisticPartner: action.payload,
        logisticmetaData: action.logisticmetaData,
      };
    }
    case GET_LOGISTICS_PARTNERS_ERROR: {
      return {
        ...state,
        isLogisticLoading: false,
      };
    }

    case PLANT_ACTIVATION_REQ: {
      return {
        ...state,
      };
    }
    case PLANT_ACTIVATION_SUCCESS: {
      return {
        ...state,
      };
    }
    case PLANT_ACTIVATION_ERROR: {
      return {
        ...state,
      };
    }

    case PLANT_REJECTION_REQ: {
      return {
        ...state,
      };
    }
    case PLANT_REJECTION_SUCCESS: {
      return {
        ...state,
      };
    }
    case PLANT_REJECTION_ERROR: {
      return {
        ...state,
      };
    }

    case LOGISTICS_REJECTION_REQ: {
      return {
        ...state,
        rejectionLoder:false
      };
    }
    case LOGISTICS_REJECTION_SUCCESS: {
      return {
        ...state,
        rejectionLoder:false
      };
    }
    case LOGISTICS_REJECTION_ERROR: {
      return {
        ...state,
        rejectionLoder:false
      };
    }

    case GET_ALLCUSTOMER_REQ: {
      return {
        ...state,
        accounts: [],
        allowedAccount: true,
      };
    }
    case GET_ALLCUSTOMER_SUCCESS: {
      return {
        ...state,
        accounts: action.payload,
        allowedAccount: false,
        metaData: action.metaData,
      };
    }

    case GET_ALLCUSTOMER_ERROR: {
      return {
        ...state,
        allowedAccount: false,
      };
    }
    case ALLOW_CUSTOMER_REQ: {
      return {
        ...state,
      };
    }
    case ALLOW_CUSTOMER_SUCCESS: {
      return {
        ...state,
      };
    }
    case ALLOW_CUSTOMER_ERROR: {
      return {
        ...state,
      };
    }
    case RESTRICT_CUSTOMER_REQ: {
      return {
        ...state,
      };
    }
    case RESTRICT_CUSTOMER_SUCCESS: {
      return {
        ...state,
      };
    }
    case RESTRICT_CUSTOMER_ERROR: {
      return {
        ...state,
      };
    }
    case GET_ORDER_BY_ID_REQ: {
      return {
        ...state,
        orderDetail: {},
        isLodadingCount: true,
      };
    }
    case GET_ORDER_BY_ID_SUCCESS: {
      return {
        ...state,
        orderDetail: action.payload,
        isLodadingCount: false,
      };
    }
    case GET_ORDER_BY_ID_ERROR: {
      return {
        ...state,
        isLodadingCount: false,
      };
    }

    case GET_LOGISTIC_BY_ID_REQ: {
      return {
        ...state,
        logisticDetail: {},
        isLogisticLoading: true,
      };
    }
    case GET_LOGISTIC_BY_ID_SUCCESS: {
      return {
        ...state,
        logisticDetail: action.payload,
        isLogisticLoading: false,
      };
    }
    case GET_LOGISTIC_BY_ID_ERROR: {
      return {
        ...state,
        isLogisticLoading: false,
      };
    }

    case ORDER_APPROVAL_REQ: {
      return {
        ...state,
      };
    }
    case ORDER_APPROVAL_SUCCESS: {
      return {
        ...state,
        orderDetail: action.payload,
      };
    }
    case ORDER_APPROVAL_ERROR: {
      return {
        ...state,
      };
    }
    case GET_NOTIFICATION_REQ: {
      return {
        ...state,
      };
    }
    case GET_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        notification: action.payload,
      };
    }
    case GET_NOTIFICATION_ERROR: {
      return {
        ...state,
      };
    }

    case GET_LOGISTICS_REQ: {
      return {
        ...state,
      };
    }
    case GET_LOGISTICS_SUCCESS: {
      return {
        ...state,
        logistics: action.payload,
      };
    }
    case GET_LOGISTICS_ERROR: {
      return {
        ...state,
      };
    }

    case GET_LOG_PARTNER_REQ: {
      return {
        ...state,
      };
    }
    case GET_LOG_PARTNER_SUCCESS: {
      return {
        ...state,
        log_partner: action.payload,
      };
    }
    case GET_LOG_PARTNER_ERROR: {
      return {
        ...state,
      };
    }
    case PLANT_TAB_PRODUCT_KEY_REQ: {
      return {
        ...state,
        plantkeyTab: action.id,
      };
    }

    case LOGISTICS_ACTIVATION_REQ: {
      return {
        ...state,
        approvalLoader: false,
      };
    }
    case LOGISTICS_ACTIVATION_SUCCESS: {
      return {
        ...state,
        approvalLoader: false,
      };
    }
    case LOGISTICS_ACTIVATION_ERROR: {
      return {
        ...state,
        approvalLoader: false,
      };
    }
    default:
      return state;
  }
}
